import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed } from 'vue';

import { BaseIcon, BaseText } from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

interface EmitEvents {
  (event: 'change', index: number): void;
}
interface Props {
  options: number;
  recommendedRisk: number;
  maxWidth: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'RiskSelectionSlider',
  props: {
    options: null,
    recommendedRisk: null,
    maxWidth: null
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'change', index: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  options: number;
  recommendedRisk: number;
  maxWidth: number;
};





const currentIndex = ref(props.recommendedRisk);

const setCurrentIndex = (index: number) => {
  currentIndex.value = index;

  emit('change', index);
};

const recomendedTitleColor = computed(() => {
  return currentIndex.value === props.recommendedRisk
    ? NebraskaColors.elementPrimary
    : NebraskaColors.elementSecondary;
});

const recomendedDescriptionColor = computed(() => {
  return currentIndex.value === props.recommendedRisk
    ? NebraskaColors.elementSecondary
    : NebraskaColors.elementDisabled;
});

onMounted(() => {
  const widhtScreen = window.screen.width;

  if (widhtScreen < props.maxWidth) {
    if (props.recommendedRisk === 1) {
      const recommended = window.document.getElementById('recommended-texts');

      recommended!.style.left = '50px';
      recommended!.style.textAlign = 'left';
    }

    if (props.recommendedRisk === props.options) {
      const recommended = window.document.getElementById('recommended-texts');

      recommended!.style.right = '50px';
      recommended!.style.textAlign = 'right';
    }
  }
});

return { __sfc: true,emit, props, currentIndex, setCurrentIndex, recomendedTitleColor, recomendedDescriptionColor, BaseIcon, BaseText }
}

})